import { useNavigate } from "react-router-dom";

import { TApiButtonCommandFn } from ".";

import { useJourney } from "modules";
import { fetchPreviousDynamicForm } from "store/actions/flow";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectPreviousDynamicFormInputPayload } from "store/selectors";

export const usePop = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isFirstForm = useAppSelector(state => state.formFlow.formIndex <= 1);
  const previousFormInputPayload = useAppSelector(selectPreviousDynamicFormInputPayload);
  const { previousStepCallback } = useJourney();

  const popCommand: TApiButtonCommandFn = async () => {
    if (!isFirstForm) {
      /*  TODO - implement 'previous' direction on fetchDynamicForm when API ready
               - remove setFormFlowIndex/fetchPreviousDynamicForm placeholder implementation
      */
      return await dispatch(fetchPreviousDynamicForm(previousFormInputPayload)).unwrap();
    } else {
      const goBackAction = () => navigate(-1);
      const callback = previousStepCallback(goBackAction);
      callback();
    }
  };

  return popCommand;
};
